import { render, staticRenderFns } from "./u-tabs-dot.vue?vue&type=template&id=6ace8d7f&scoped=true&"
import script from "./u-tabs-dot.vue?vue&type=script&lang=js&"
export * from "./u-tabs-dot.vue?vue&type=script&lang=js&"
import style0 from "./u-tabs-dot.vue?vue&type=style&index=0&id=6ace8d7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace8d7f",
  null
  
)

export default component.exports